import UploadInformation from './UploadInformation.component';

export default UploadInformation;
